const MerchandizerMaster = {
    Add_New_Merchandizer: 'Add New Merchandizer',
    Add_New_Merchandizing_Executive: 'Add New Merchandizing Executive',
    Update_Information: 'Update Information',
    NewMerchandizeSuccess: 'New Merchandizer added successfully',
    UpdateMerchandizerSuccess: 'Merchandizer updated successfully',
    UploadMerchandizerError: "Merchandizer unable to add/update due to error. Kindly add again",
    Add_new_PJP: "Add new PJP",
    Add_Journey_Plan: "Add new Journey Plan",
    NewPJPAddedSuccessfully: "New PJP added successfully",
    UpdatePJPSuccess: 'Journey plan updated successfully',
    UploadPJPError: "PJP unable to add/update due to error. Kindly add again",
    PJPUploadInProgressMessage: "A file is still being processed for this master. Wait for it to finish before uploading another.",
    UpdateRouteMasterSuccess: "Route Master updated successfully",
    UploadRouteMasterError: "Route Master unable to update due to error. Kindly add again",
    Add_New_Supervisor: "Add New Supervisor",
    Update_Supervisor_Information: "Update Supervisor Information",
    NewSupervisorAddedSuccessfully: "New Supervisor added successfully",
    UpdateSupervisorSuccess: "Supervisor updated successfully",
    UploadSupervisorError: "Supervisor unable to add/update due to error. Kindly add again",
    UpdateFieldForceSuccess: "Field Force updated successfully",
    UploadFieldForceError: "Field Force unable to update due to error. Kindly add again",
}

export default MerchandizerMaster;